/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Row } from "react-bootstrap";
import { ILayers } from "../../../../../shared/interfaces/ILayers";
import { IWeGeoLegends } from "../../../../../shared/interfaces/ILegends";
import {
    IProperty,
    IPropertyGeom,
} from "../../../../../shared/interfaces/IProperties";
import { Croqui } from "../../../bci/croquis/map";
import { ConsultaPreviaMapContainer } from "../../palmeira/style";

interface ZoneamentoProps {
    propertyInfo?: IProperty;
    propertyGeom?: IPropertyGeom;
    layers?: ILayers[];
}

export const ZoneamentoPalmeira: React.FC<ZoneamentoProps> = ({
    propertyInfo,
    propertyGeom,
    layers,
}) => {
    return (
        <Row>
            <table className="table table-striped">
                <tbody>
                    {propertyInfo?.inscricaoimobiliaria && (
                        <tr>
                            <td>Inscrição Imobiliária:</td>
                            <td>{propertyInfo?.inscricaoimobiliaria}</td>
                            {propertyGeom && layers && (
                                <td rowSpan={12} colSpan={2}>
                                    <ConsultaPreviaMapContainer>
                                        <Croqui
                                            layers={layers}
                                            propertyGeom={propertyGeom}
                                            padding={[145, 145, 145, 145]}
                                        />
                                    </ConsultaPreviaMapContainer>
                                </td>
                            )}
                        </tr>
                    )}

                    {propertyInfo?.cadastro && (
                        <tr>
                            <td>Cadastro:</td>
                            <td>{propertyInfo?.cadastro}</td>
                        </tr>
                    )}

                    {propertyInfo?.matricula && (
                        <tr>
                            <td>Matrícula:</td>
                            <td>{propertyInfo?.matricula}</td>
                        </tr>
                    )}

                    {propertyInfo?.logradouronome && (
                        <tr>
                            <td>Endereço:</td>
                            <td>{propertyInfo?.logradouronome}</td>
                        </tr>
                    )}

                    {propertyInfo?.logradouronumero && (
                        <tr>
                            <td>Número:</td>
                            <td>{propertyInfo?.logradouronumero}</td>
                        </tr>
                    )}

                    {propertyInfo?.bairronome && (
                        <tr>
                            <td>Bairro: </td>
                            <td>{propertyInfo?.bairronome}</td>
                        </tr>
                    )}

                    {propertyInfo?.cep && (
                        <tr>
                            <td>CEP:</td>
                            <td>{propertyInfo?.cep}</td>
                        </tr>
                    )}

                    {propertyInfo?.quadra && (
                        <tr>
                            <td>Quadra:</td>
                            <td>{propertyInfo?.quadra}</td>
                        </tr>
                    )}

                    {propertyInfo?.lote && (
                        <tr>
                            <td>Lote:</td>
                            <td>{propertyInfo?.lote}</td>
                        </tr>
                    )}

                    {propertyInfo?.zoneamento && (
                        <tr>
                            <td>Zoneamento:</td>
                            <td>
                                {propertyInfo?.zoneamento?.zona_uso.toUpperCase()}
                            </td>
                        </tr>
                    )}

                    {propertyInfo?.zoneamento?.zona &&
                        propertyInfo?.zoneamento?.zona.includes("SIM") && (
                            <tr>
                                <td colSpan={3}>
                                    LOTE EM ÁREA PRESERVAÇÃO PERMANENTE
                                </td>
                            </tr>
                        )}

                    {/* {propertyInfo?.zoneamento && (
                        <tr>
                            <td>Zoneamento:</td>
                            <td colSpan={2}>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Sigla</th>
                                            <th>Observaçao</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                {propertyInfo?.zoneamento?.zona_uso.toUpperCase()}
                                            </td>
                                            <td>
                                                {
                                                    propertyInfo?.zoneamento
                                                        ?.observacao
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    )} */}
                </tbody>
            </table>
        </Row>
    );
};
